module.exports = __webpack_public_path__ + "img/facebook.5b7ac131.svg";